import { render } from "./account_statements.vue?vue&type=template&id=1544bfaa&scoped=true"
import script from "./account_statements.vue?vue&type=script&lang=js"
export * from "./account_statements.vue?vue&type=script&lang=js"

import "./account_statements.vue?vue&type=style&index=0&id=1544bfaa&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1544bfaa"]])

export default __exports__